import GameplayScene from "@/scenes/Gameplay.scene";
import LoadingScene from "@/scenes/Loading.scene";
import SplashScene from "@/scenes/Splash.scene";
export default {
    backgroundColor: "#2f2f3a",
    batchSize: 512,
    fps: {
        min: 30,
        target: 60,
        smoothStep: true,
        forceSetTimeOut: true,
    },
    input: {
        activePointers: 3,
    },
    physics: {
        default: "arcade",
        arcade: {
            gravity: { x: 0, y: 0 }, // Eksik olan x ekseni eklendi
            debug: false,
        },
    },
    powerPreference: "high-performance",
    scale: {
        mode: Phaser.Scale.ScaleModes.ENVELOP,
        autoCenter: Phaser.Scale.Center.CENTER_BOTH,
        width: 1920,
        height: 1080,
    },
    scene: [SplashScene, LoadingScene, GameplayScene],
    type: Phaser.AUTO,
};
